const digest = 'd8f315131c8bf58d9cc3c3fe43cafd6416351398a304a416523250f27759d47f';
const css = `._mainContainerWrapperWithNavbar_2fjwu_1{padding-bottom:4.6625rem}._hideDismissButton_2fjwu_5>:last-child{display:none}._errorBanner_2fjwu_9._hideDismissButton_2fjwu_5{padding-right:.5rem!important}._link_2fjwu_13{font-size:.875rem!important;min-width:unset!important;vertical-align:unset!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'mainContainerWrapperWithNavbar': '_mainContainerWrapperWithNavbar_2fjwu_1', 'hideDismissButton': '_hideDismissButton_2fjwu_5', 'errorBanner': '_errorBanner_2fjwu_9', 'link': '_link_2fjwu_13' };
export const mainContainerWrapperWithNavbar = '_mainContainerWrapperWithNavbar_2fjwu_1';
export const hideDismissButton = '_hideDismissButton_2fjwu_5';
export const errorBanner = '_errorBanner_2fjwu_9';
export const link = '_link_2fjwu_13';
export { css, digest };